'use client';

import React from 'react';
import Image from 'next/image';
import { ADVANCED_LABS_RAF_IMAGE } from '@/lib/constants/images';
interface AdvancedLabsLandingPageSubtext extends React.HTMLAttributes<HTMLDivElement> {
  desktopSubtext: string;
  mobileSubtext: string | React.ReactNode;
}
export default function AdvancedLabsLandingPageSubtext({
  desktopSubtext,
  mobileSubtext
}: AdvancedLabsLandingPageSubtext) {
  return <div className='flex w-full items-center justify-center px-6 pb-7 text-left' data-sentry-component="AdvancedLabsLandingPageSubtext" data-sentry-source-file="AdvancedLabsLandingPageSubtext.tsx">
      <div className='bg-green-radial flex w-80 flex-row items-center rounded-2xl pl-1 pr-4 text-white md:w-auto md:max-w-xl'>
        <Image alt='phone' height={95} src={ADVANCED_LABS_RAF_IMAGE} width={88} data-sentry-element="Image" data-sentry-source-file="AdvancedLabsLandingPageSubtext.tsx" />
        <div className='flex h-full flex-col items-center'>
          <p className='hidden text-sm font-light md:block'>{desktopSubtext}</p>
          <p className='text-left text-sm font-light md:hidden'>
            {mobileSubtext}
          </p>
        </div>
      </div>
    </div>;
}